import { AmountToggleInput as AmountToggleInputType } from '../../../../../../types/Survey/Element'
import { AmountToggleInput as AmountToggleInputAnswerType } from '../../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'

const AmountToggleInput: React.FC<Props<AmountToggleInputType, AmountToggleInputAnswerType>> = ({ element, answerElement }) => {
  return (
    <div>
      <Core element={element} />
      <div className="mt-3">
        {answerElement.isEnabled ? (
          <div>
            <div className="font-bold">{element.yesLabel}</div>
            <div>{`${answerElement.amount} ${element.amountSuffix}`}</div>
          </div>
        ) : (
          <div className="font-bold">{element.noLabel}</div>
        )}
      </div>
    </div>
  )
}

export default AmountToggleInput
